module.exports = __webpack_public_path__ + "static/media/10.9eb36e1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/10.jpg
// module id = 78
// module chunks = 0